module.exports = __webpack_public_path__ + "img/Shopify.7cc0717c.webp";